module.exports = __webpack_public_path__ + "Power of Attorney.pdf";